import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import ChecklistDataGridView from "../ChecklistDataGridView";
export var ChecklistView = [{
        type: FormItemTypes.ContainerItem,
        name: "table",
        columnSize: 12,
        spacing: 0,
        elements: [{
                type: FormItemTypes.Custom,
                name: "catalog",
                columnSize: 12,
                element: ChecklistDataGridView
            }]
    }];
